import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <h1>404</h1>
        <h2>Page Not Found</h2>
        <p>
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
          <br />
          <span className="mcgp">MCGPchain</span> has much more to explore.
        </p>
        <div className="not-found-actions">
          <Link to="/" className="home-button">
            Return Home
          </Link>
          <Link to="/community" className="community-button">
            Join Community
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
